"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var foxEgg = {
    name: "fox",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["f", "o", "x"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/9OtfVY4.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "500px";
        img.style.height = "400px";
        img.style.transition = "30s all";
        img.style.position = "fixed";
        img.style.right = "-400px";
        img.style.bottom = "calc(-50% + 280px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.right = "calc(100% + 500px)";
        }, 50);
        // window.setTimeout(function(){
        //   img.style.right = 'calc(100% + 375px)';
        // }, 4500);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 30300);
    },
};
exports.default = foxEgg;
